export enum SagaActions {
  Auth = 'Authentication',
  GetPacks = 'GetPacks',
  GetOnePack = 'GetOnePack',
  DeleteCard = 'DeleteCard',
  UpdateCard = 'UpdateCard',
  CreateCard = 'CreateCard',
  AddPack = 'AddPack',
  UpdatePack = 'UpdatePack',
  DeletePack = 'DeletePack',
  RateCard = 'RateCard',
  Restore = 'Restore',
}
